// Module
var code = "<div class=\"hero-heading\">\n  <logo></logo>\n  <h1>{{ heading }}</h1>\n</div>\n";
// Exports
export default code;